
export default {
  name: "Search",

  data: function () {
    return {
      result: [],

      search: "",

      isLoad: false,
      isOpen: false,

      timeOutChangeSearch: null
    }
  },

  watch: {
    search: function () {
      clearTimeout(this.timeOutChangeSearch);

      this.isLoad = Boolean(this.search.length >= 2);
      if (this.search.length < 2) {
        this.isLoad = false;

        return
      }
      this.timeOutChangeSearch = setTimeout( async () => {
        await this.getResult();
      }, 1000);
    },
    isOpen: async function () {
      if (!this.isOpen) {
        return
      }
      await new Promise(r => setTimeout(r, 500));
      this.$refs.redInputSearch.focus();
    }
  },

  methods: {
    openDropdown: function () {
      this.isOpen = true;
      this.result = [];
    },
    closeDropdown: function () {
      this.search = "";
      this.isOpen = false;
      this.result = [];
    },

    getResult: async function () {
      const response = await this.$api.agent.transport.get(`/catalog/search?query=${ this.search }&expand=characteristicGroup`).then((res) => {
        return res.data?.results || {}
      }).catch(() => {
        return {}
      });
      let sections = Object.keys(response)
        .map((key) => {
        const item = response[key];
        if (item.total <= 0) {
          return
        }

        item.index = key;
        return item
      })
        .filter((t) => !!t);

      sections = sections.map((content) => {
        let name = content?.name || "";
        if (content.index === "products") {
          name = content?.items?.[0]?.characteristicGroup?.name || content?.name;
        }

        return {
          ...content,
          name
        }
      })

      this.result = sections;
      this.isLoad = false;
    },

    routeSearchPage: function () {
      this.$router.push(`/search?data=${this.search}`);
      this.closeDropdown();
    }
  }
}
